import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import { FormsModule } from '@angular/forms';
import { MileageHistoryComponent } from './components/mileage-history/mileage-history.component';
import { PaceCoreModule } from '@evorait/pace-core';

@NgModule({
    declarations: [MileageHistoryComponent],
    imports: [CommonModule, SharedModule, CoreModule, FormsModule, PaceCoreModule.forChild()],
    exports: [MileageHistoryComponent],
})
export class MileageModule {}
